// extracted by mini-css-extract-plugin
export default {"container":"checkbox_container__M7+--","checkmark":"checkbox_checkmark__Ll7+e","checkmarkstyle":"checkbox_checkmarkstyle__QzDW+","main":"checkbox_main__XPY-F"};